export enum PerformanceDevelopmentYRangeNameEnum {
  LEFT_Y_1 = 'leftY1',
  LEFT_Y_2 = 'leftY2',
  RIGHT_Y_1 = 'rightY1',
}
